/**
 * 下载组件
 * created by yxy
 *
 */


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Icon, Modal} from 'antd';
import {message} from './Mess';
import BaseComponent from "../../../base/BaseComponent";
import {deleteTaskById} from "../../../actions/majorProjects";
import {AUDIO_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../constants";
const { confirm } = Modal


export default class DownLoad  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            history:require("history").createHashHistory(),
        }
    }
    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {
        let right =  this.props.marginRight?this.props.marginRight: 5;
        return(
            <div style={{marginRight:right,cursor:'pointer'}}  >{
                this.props.text?<span onClick={() => this.gotoBatchDownload()} >下载</span>:<Button onClick={() => this.gotoBatchDownload()}  icon={"download"}
               >下载</Button>
            }
            </div>
        )
    }
    gotoBatchDownload() {
        this.props.hideCallBack&&this.props.hideCallBack();
        let download_number = 1;   //可直接下载的个数
        let downloadNum = [];

        if (this.props.checkArray.length) {
            let fileList = [];
            let num = 0;
            let ids=[];
            this.props.checkArray.forEach((item, index) => {
                if (item.fileTypeEnum === 'DIR' ||(item.fileTypeEnum === "LINK"&&item.size === 0 )) {
                    num++
                } else {
                    if(item.extendedAttributeJson&&item.extendedAttributeJson.download){
                        downloadNum.push(item)
                    }
                    if(this.props.IsDefault){
                        ids.push(item.virtualFileId)
                    }else{
                        ids.push(item.id)
                    }
                    fileList.push(item)
                }
            });
            this.public(num,fileList,downloadNum,download_number,ids)
        } else {
            message.error('至少选择一个文件！')
        }
    }
    // 下载：
    // 1、含文件夹：（暂不支持文件夹下载。）
    // 2、含未公开资源、公开资源：（所选资源包含未公开资源，请申请下载，当前仅下载公开资源？）
    // 3、未公开资源：（所选资源为未公开资源，请申请下载。）
    // 4、公开资源：直接下载
    public(num,fileList,downloadNum,download_number,ids){
        if(num>0){
            message.error('暂不支持文件夹下载！');
            return  false
        }
        if(downloadNum.length>0){
            message.error('所选资源中，存在需要申请下载的资源，请重新选择！');
            return  false
        }
        if(fileList.length>download_number){
            this.confirm(ids,'确认下载当前文件？')
        }else{
            this.SecondConfirm(fileList,'确认下载当前文件？')
        }

    }
  // 下载未超过规定的个数的二次确认
    SecondConfirm(fileList,text){
            confirm({
                title: text,
                okText: '确定',
                cancelText: '取消',
                onOk:()=> {
                    fileList.forEach((item)=>{
                        let id= item.id;
                        let  downloadFlag = false;
                        if(this.props.IsDefault){
                            id= item.virtualFileId;
                        }
                        let parms={
                            virtualFileId:id,
                            name:item.name,
                            downloadFlag:downloadFlag
                        };
                        this.request({
                            url: "/cm-sites-storage-management/zykDownLoad/addZykDownLoad",
                            method: "post",
                            body:parms,
                            contentType:'json',
                            callBack: (data) => {
                                if(data){
                                    let url = "/storage/downloadFile?md5="+data.md5+'&download=1'+'&name='+item.name
                                    let aObj = document.createElement('a');
                                    aObj.setAttribute('download','');
                                    aObj.setAttribute('href',url);
                                    aObj.click()
                                    aObj = null;
                                    let fileType = '';
                                    if(PIC_TYPE.indexOf(item.suffix)>-1) {
                                        fileType = 1;
                                    }else if(VIDEO_TYPE.indexOf(item.suffix)>-1){
                                        fileType = 2;
                                    }else if(AUDIO_TYPE.indexOf(item.suffix)>-1){
                                        fileType = 3;
                                    }else {
                                        fileType = 4;
                                    }
                                    let { downloadNeedKey } = this.props;
                                    let body = {
                                        id:downloadNeedKey?item[downloadNeedKey]:item.id,
                                        fileName:item.name,   //String 文件名称
                                        fileIcon:item.icon,   //String 文件显示缩略图
                                        type:fileType,        //Integer 文件类型 参考前面保持一致
                                        md5:data.md5,         //String 文件的md5
                                        size:item.size,        //long  文件大小
                                    }
                                    this.request({
                                        url: "/cm-sites-storage-management/zykStatistics/addDownloadRecords",
                                        method: "post",
                                        body:body,
                                        contentType:'json',
                                    })
                                    // this.props.callBack&&this.props.callBack(this.props.currentId,this.props.current, [],true,false);
                                   this.props.callBack&&this.props.callBack()
                                }
                            }
                        });
                    })
                },
                onCancel() {
                },
            });
        }

  //下载次数超过规定的个数确认按钮
    confirm(ids,text){
        confirm({
            content: text,
            okText: '确定',
            cancelText: '取消',
            onOk:()=> {
                this.request({
                    url: "/cm-sites-storage-management/zykDownLoad/batchDownLoad",
                    method: "post",
                    body:{virtualFileIds:ids.join(',')},
                    contentType: "json",
                    callBack: (data) => {
                        this.request({
                            url: '/cm-sites-storage-management/zykStatistics/addBatchDownloadRecords',
                            method: 'post',
                            body: {zipIds:data.virtualFileId,virtualFileIds:ids},
                            contentType: 'json',
                            callBack: () => {
                            }
                        }
                    )
                        Modal.confirm({
                            title: '已成功添加下载队列',
                            content: '请前往“我的下载”页面查看下载',
                            okText: "确定前往",
                            cancelText: '关闭',
                            icon: <Icon type="check-circle"/>,
                            onOk: () =>{
                                this.state.history.push("/view/downLoad/downLoad");
                            },
                            onCancel:() =>{
                            }
                        });
                    }
                });
            },
            onCancel() {
            },
        });
    }

}
